var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceNeutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 58,
    viewBox: "0 0 56 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 6.64581C16.0798 6.64581 6.41666 16.6541 6.41666 29C6.41666 41.3458 16.0798 51.3541 28 51.3541C39.9201 51.3541 49.5833 41.3458 49.5833 29C49.5833 16.6541 39.9201 6.64581 28 6.64581ZM2.91666 29C2.91666 14.6521 14.1468 3.02081 28 3.02081C41.8531 3.02081 53.0833 14.6521 53.0833 29C53.0833 43.3479 41.8531 54.9791 28 54.9791C14.1468 54.9791 2.91666 43.3479 2.91666 29ZM19.25 38.6666C19.25 37.6656 20.0335 36.8541 21 36.8541H35C35.9665 36.8541 36.75 37.6656 36.75 38.6666C36.75 39.6677 35.9665 40.4791 35 40.4791H21C20.0335 40.4791 19.25 39.6677 19.25 38.6666Z",
    fill: "#3C3C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 25.375C37.3333 27.377 36.2887 29 35 29C33.7113 29 32.6667 27.377 32.6667 25.375C32.6667 23.3729 33.7113 21.75 35 21.75C36.2887 21.75 37.3333 23.3729 37.3333 25.375Z",
    fill: "#3C3C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 25.375C23.3333 27.377 22.2887 29 21 29C19.7113 29 18.6667 27.377 18.6667 25.375C18.6667 23.3729 19.7113 21.75 21 21.75C22.2887 21.75 23.3333 23.3729 23.3333 25.375Z",
    fill: "#3C3C3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceNeutral);
export default __webpack_public_path__ + "static/media/face-neutral.99ed35e9.svg";
export { ForwardRef as ReactComponent };